var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlueVerifiedCheck = function SvgBlueVerifiedCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-.95 -.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4389CF",
    points: "12 21.299 8.601 22.462 6.534 19.523 3.101 18.466 3.156 14.874 1 12 3.156 9.126 3.101 5.534 6.534 4.477 8.601 1.538 12 2.701 15.399 1.538 17.466 4.477 20.899 5.534 20.844 9.126 23 12 20.844 14.874 20.899 18.466 17.466 19.523 15.399 22.462"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.3381863,7.33440532 C16.6999463,6.90940516 17.3074225,6.88643645 17.6950225,7.28310326 C18.0826225,7.67977008 18.1035699,8.34586277 17.7418099,8.77086293 L11.0218217,16.6655896 C10.6708361,17.0779318 10.085814,17.1136477 9.69525123,16.7465772 L6.3352571,13.5886865 C5.93270499,13.2103479 5.886086,12.5458225 6.23113066,12.1044274 C6.57617532,11.6630324 7.18222225,11.611915 7.58477435,11.9902537 L10.246083,14.4914847 L16.3381863,7.33440532 Z"
  }))));
};
export default SvgBlueVerifiedCheck;